import { render, staticRenderFns } from "./user-dash-quick-act.vue?vue&type=template&id=252c84d8&"
import script from "./user-dash-quick-act.vue?vue&type=script&lang=js&"
export * from "./user-dash-quick-act.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports